import { render, staticRenderFns } from "./HeaderSubcategoriesComponent.vue?vue&type=template&id=4a153f78"
import script from "./HeaderSubcategoriesComponent.vue?vue&type=script&lang=js"
export * from "./HeaderSubcategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderSubcategoriesComponent.vue?vue&type=style&index=0&id=4a153f78&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports